import React, { useEffect } from "react";
import "../styles/Home.css";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export default function Home() {
  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls to the top when this component mounts
  }, []);
  return (
    <motion.div 
      className="home-container"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
    >

      <div className="header"></div>

      <motion.div className="home-contents"
        initial={{ y: -50, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
      >
        <motion.div className="home"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5, duration: 0.8 }}
        >
          <h1 className="home-heading">
          Unlocking Potential Through Drone Education and Technology
          </h1>
          <p className="home-para">
            Innovative drone service in South Africa, empowering businesses and communication alike.
          </p>
          <motion.button
            className="home-btn"
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
          >
            Explore Our Services
          </motion.button>
        </motion.div>

        <motion.div className="features"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.8, duration: 1 }}
        >
          <h2 className="section-heading">Our Key Features</h2>
          <div className="features-list">
            <motion.div
              className="feature-item"
              whileHover={{ scale: 1.05 }}
              initial={{ x: -20, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              transition={{ duration: 0.5 }}
            >
              <h3>High-Resolution Imaging</h3>
              <p>Capture stunning aerial visuals with industry-leading camera technology.</p>
            </motion.div>
            <motion.div
              className="feature-item"
              whileHover={{ scale: 1.05 }}
              initial={{ x: -20, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              transition={{ duration: 0.6 }}
            >
              <h3>Customizable Drone Services</h3>
              <p>Tailored solutions to fit diverse business needs, from agriculture to construction.</p>
            </motion.div>
            <motion.div
              className="feature-item"
              whileHover={{ scale: 1.05 }}
              initial={{ x: -20, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              transition={{ duration: 0.7 }}
            >
              <h3>Real-Time Data Analytics</h3>
              <p>Analyze data on-the-fly to make informed decisions quickly and accurately.</p>
            </motion.div>
          </div>
        </motion.div>

        {/* New Specialization Section */}
        <motion.div className="specialization"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1, duration: 1 }}
        >
          <h2 className="section-heading">Our Specializations</h2>
          <div className="specialization-list">
            <motion.div
              className="specialization-item"
              whileHover={{ scale: 1.05 }}
              initial={{ x: -20, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              transition={{ duration: 0.5 }}
            >
              <h3>Drone Services</h3>
              <p>Comprehensive drone solutions for various industries including agriculture, security, and construction.</p>
            </motion.div>
            <motion.div
              className="specialization-item"
              whileHover={{ scale: 1.05 }}
              initial={{ x: -20, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              transition={{ duration: 0.6 }}
            >
              <h3>Drone Technology Awareness Campaign in Disadvantaged Schools</h3>
              <p>Empowering students in underserved communities through exposure to drone technology and STEM education.</p>
            </motion.div>
            <motion.div
              className="specialization-item"
              whileHover={{ scale: 1.05 }}
              initial={{ x: -20, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              transition={{ duration: 0.7 }}
            >
              <h3>Free Mathematics and English Mentoring for Aspiring Remote Pilots</h3>
              <p>Supporting aspiring remote pilots with essential skills in mathematics and English for career readiness.</p>
            </motion.div>
          </div>
        </motion.div>

        {/* Testimonials Section */}
        <motion.div className="testimonials"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1, duration: 1 }}
        >
          <h2 className="section-heading">What Our Clients Say</h2>
          <motion.div className="testimonial-item"
            whileHover={{ scale: 1.02 }}
            initial={{ x: -20, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.8 }}
          >
            <p>
              "Their drone services transformed our project management! The data accuracy is unmatched."
            </p>
            <span>- Sarah D., Construction Project Manager</span>
          </motion.div>
          <motion.div className="testimonial-item"
            whileHover={{ scale: 1.02 }}
            initial={{ x: -20, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.9 }}
          >
            <p>
              "We now reach more clients and communicate visually in ways we never thought possible."
            </p>
            <span>- John M., Marketing Director</span>
          </motion.div>
        </motion.div>

        <motion.div className="cta-section"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.2, duration: 1 }}
        >
          <h2>Ready to Transform Your Business?</h2>
          <p>Contact us to explore how our drone solutions can elevate your operations.</p>
          <Link to="/contact">
            <motion.button
              className="cta-btn"
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.9 }}
            >
              Contact Us
            </motion.button>
          </Link>
        </motion.div>
      </motion.div>
    </motion.div>
  );
}
